import React, {useContext, useEffect} from 'react';
import {Grid} from '@material-ui/core';
import InputField from '../../../../FormikUtils/InputField';
import SelectField from '../../../../FormikUtils/SelectField';
import {useFormikContext} from "formik";
import Divider from "@material-ui/core/Divider";
import SlantedField from "../../../../FormikUtils/SlantedField";
import CotizarContext from "../../../../../../context/CotizarContext";
import ExpirationDateField from '../../../../FormikUtils/ExpirationDateField/ExpirationDateField';

export default function PolizaForm(props) {
    const {
        formField: {
            vigenciaDesde,
            vigenciaHasta,
            frecuenciaPago,
            formaDePago,
            infoDePago: {
                numeroCbu,
                marcaTarjeta,
                numeroTarjeta,
                vencimientoTarjeta,
            },
            moduloCobertura,
        }
    } = props;
    const {values, setFieldValue} = useFormikContext();
    const {dictModulosEmision, TR_ID_MODULOS} = useContext(CotizarContext)

    const formasDePago = [
        {value: '0', label: 'Efectivo'},
        {value: '4', label: 'Débito por CBU'},
        {value: '2', label: 'Tarjeta de crédito'}
    ];

    const idsTarjeta = [
        {value: '1', label: 'Cabal'},
        {value: '5', label: 'Visa'},
        {value: '7', label: 'Favacard'},
        {value: '9', label: 'American Express'},
        {value: '12', label: 'Naranja'},
        {value: '16', label: 'Diners Club'},
        {value: '18', label: 'Naranja Visa'},
        {value: '20', label: 'Cordobesa - Matercard'},
        {value: '23', label: 'TDF - Tierra del Fuego'},
        {value: '45', label: 'Mastercard Nueva'},
        {value: '57', label: 'ELEBAR'},
        {value: '70', label: 'Censosud  Mastercard'},
    ];

    const frecuencias = [
        {value: '5', label: 'Anual'},
    ];

    function add_years(dt) {
        let date = new Date(dt.setYear(dt.getFullYear() + 1));
        const offset = date.getTimezoneOffset()
        date = new Date(date.getTime() - (offset * 60 * 1000))
        date = date.toISOString().split('T')[0]
        return date
    }

    useEffect(() => {
        let date;
        if (new Date(values.vigenciaDesde.replace(/-/g, '/')) > new Date().getDate() - 1) {
            date = new Date(values.vigenciaDesde.replace(/-/g, '/'));
                setFieldValue("vigenciaHasta", add_years(date).toString())
        }
    }, [values.vigenciaDesde])
    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={frecuenciaPago.name}
                        label={frecuenciaPago.label}
                        data={frecuencias}
                        disabled
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider variant="middle"/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={vigenciaDesde.name}
                        label={vigenciaDesde.label}
                        type="date"
                        fullWidth
                        InputLabelProps={{shrink: true,}}
                        textTransform={'lowercase'}

                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SlantedField value={values.vigenciaHasta.split('-').reverse().join('/')}
                                  label={vigenciaHasta.label}/>
                </Grid>

                <Grid item xs={12} md={6}>
                    {/*    COMPONENTE SESGADO   */}
                    <SlantedField
                        value={
                            TR_ID_MODULOS.includes(values.moduloCobertura.toString())
                                ? values.nombreModulo.split('Auto ')
                                : dictModulosEmision[values.moduloCobertura].nombreModulo
                        }
                        label={moduloCobertura.label}/>
                </Grid>

                <Grid item xs={12}>
                    <Divider variant="middle"/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <SelectField
                        name={formaDePago.name}
                        label={formaDePago.label}
                        data={formasDePago}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={0} md={6}/>
                {values.formaDePago === '2' && (
                    <Grid item container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                name={`infoDePago.${marcaTarjeta.name}`}
                                label={marcaTarjeta.label}
                                data={idsTarjeta}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputField
                                name={`infoDePago.${numeroTarjeta.name}`}
                                label={numeroTarjeta.label}
                                textTransform={'uppercase'}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <ExpirationDateField
                                name={`infoDePago.${vencimientoTarjeta.name}`}
                                label='Fecha de vencimiento'
                                isRequired
                            />
                        </Grid>
                    </Grid>
                )}
                {values.formaDePago === '4' && (
                    <Grid item container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <InputField
                                name={`infoDePago.${numeroCbu.name}`}
                                label={numeroCbu.label}
                                textTransform={'uppercase'}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </React.Fragment>
    );
}
